import almanews_logo from "../../almanews_logo.svg";
import almalogo from "../../assets/alma_logo.png";

const LoggedoutHeader = ({ alma_headers_urls, ...props }) => {
    var logo = almanews_logo;
    if (alma_headers_urls.includes(window.location.pathname)) logo = almalogo;
    return (
        <div className="header header--centered">
            <div className="header-inner">
                <a href="/">
                    <img src={logo} className="header-logo" />
                </a>
            </div>
        </div>
    );
};

export default LoggedoutHeader;
